const ViewTabsWrapper = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  return (
    <div className="w-fit flex absolute top-[7px] left-0 gap-[var(--spacing-xs)]">
      {children}
    </div>
  );
};

export default ViewTabsWrapper;
